export const formatMonth = (yyyyDashMM: string) => {
  const [y, m] = yyyyDashMM.split("-");
  return { y, m };
};

export const formatDate = (date: string) => {
  const now = new Date(`${date}T00:00:00`);
  return now.toLocaleDateString("pt-BR");
};

export const formartNumberToPercentage = (n: number) =>
  new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(n);

export const formartNumberToInteger = (n: number) =>
  new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 }).format(n);

export const formatCurrency = (value: string) =>
  new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(Number.parseFloat(value ?? "0"));

export const formatToLocaleString = (value: number) =>
  new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    style: "decimal",
    currency: "BRL",
  }).format(value);

export const formatToISODate = (d?: Date | null) => {
  if (!d) return "";
  const z = new Date(d);
  if (!Number.isFinite(z.getTime())) return "";
  return z.toISOString().split("T")[0];
};
